import React, { useEffect, useState,useRef} from "react";
import PropTypes from "prop-types";

import ApplicationComponent from "./ApplicationComponent";

import { LoadProfileActionDisplay } from '../../../redux/actions/ProfileActions';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../styles/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import SimpleMenu from "../../../components/layouts/Navigation";
import { spacing } from "@material-ui/system";
import { Box } from "@material-ui/core";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { DropzoneArea } from "material-ui-dropzone";
import Divider from '@material-ui/core/Divider';
import Geographical from "../../../constants/Geographical.json";
import CompanyDetails from "./CompanyComponent";
import CustomerGeneralInfo from "./CustomerGeneralInfo";
import AuthorizationErrorComponent from '../../AuthorizationErrorComponent';
import {CustomerGeneralInfoStoreAction} from '../../../redux/actions/CustomerAction';
import {useDispatch, useSelector} from 'react-redux';

const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    spacing: 8,
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#40a9ff",
    },
    "& > *": {
      margin: theme.spacing(1),
      width: "50ch"
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const StyledTabs = withStyles({
  scrollButtons: {
    "&.Mui-disabled": {
      opacity: 0.3
    }
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 40,
      width: "100%",
      backgroundColor: "#635ee7",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#fff",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

export default function CustomizedTabs() {


  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showPanelLicense,setShowPanelLicense] = useState(false);
  const [showPanelCompany, setShowPanelCompany] = useState(false);
  const [showMenu,setShowMenu] = useState(false);
  const [runFirstPanel,setRunFirstPanel] = useState(true);
  const [readableStatus,setReadableStatus] = useState(false);
  const [restrictedStatus, setRestrictedStatus] = useState(false);
  const [restrictedResponse, setRestrictedResponse] = useState("");
  const [profileDisplay,setProfileDisplay]=useState(true);
  const [companyDisplay, setCompanyDisplay] = useState(false);
  const [disableEdit, setDisableEdit] = useState(true);
  const [individual, setIndividual] = useState(false);
  
  
  const profileResponse = useSelector(state => state.userDetails.userProfile);
  const [companyRefresh, setCompanyRefresh]=useState(false);
  
  const dispatch = useDispatch();
    
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={2}>{children}</Box>}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }
  
  useEffect(() => {
    setLoading(true)
    dispatch(LoadProfileActionDisplay(setProfileDisplay, setCompanyDisplay, setDisableEdit, setShowPanelLicense, setIndividual));
    setCompanyRefresh(false)
    setLoading(false)
    return () => {};
  }, [showPanelLicense]);
  return (
    <>  <div className={classes.root}>
      {loading && <Grid container className={classes.bodyWrapper} style={{ position: "absolute", top: "30%", left: "50%", transform: 'translate("-50%","-50%")', fontSize: "24px" }}><span >Loading .....</span></Grid>}
      {!loading &&

        <>
      {restrictedStatus && 
        <> <Grid container className={classes.bodyWrapper}>
        <Grid item xs={12} style={{height:"100vh"}}> <AuthorizationErrorComponent error={restrictedResponse.message}/>
        
        </Grid>
        </Grid>
        </>
        }
      {!restrictedStatus && 
     
        <Grid container className={classes.bodyWrapper}>
      
           
         {showMenu && 
          <Grid item xs={2} md={2} >
            
          </Grid>
}

          <Grid item xs={12} md={9} style={{ marginLeft:"auto",marginRight:"auto",marginTop: "25px"}}>
            <div className={classes.demo1}>
                 {!individual &&  <>
              <AntTabs
                value={value}
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChange}
              >
                    <AntTab label="Authorized Personnel" {...a11yProps(0)} />
              {/* <AntTab label="Company Official Docs" {...a11yProps(1)} /> */}
                  {companyDisplay ? <AntTab label="Company Official Docs" {...a11yProps(1)} /> : ""}
                    {(profileDisplay == true || showPanelLicense)  && <AntTab label="Apply Application" {...a11yProps(2)} />}
          
               </AntTabs>
              <TabPanel value={value} index={0}>
                      <CustomerGeneralInfo setShowPanelLicense={setShowPanelLicense} setShowPanelCompany={setShowPanelCompany} setShowMenu={setShowMenu} setRunFirstPanel={setRunFirstPanel} runFirstPanel={runFirstPanel} handleChange={handleChange} setReadableStatus={setReadableStatus} setRestrictedResponse={setRestrictedResponse} setRestrictedStatus={setRestrictedStatus} disableEdit={disableEdit} loading={loading} setLoading={setLoading}/>
            </TabPanel>
                
              {companyDisplay ?
                
              <TabPanel value={value} index={1}>
                 
               
                    <CompanyDetails readableStatus={readableStatus} />
              
              </TabPanel>:""}
              
                { (profileDisplay == true || showPanelLicense)?
              <TabPanel value={value} index={2}>
                    <ApplicationComponent/>
              </TabPanel>:""}
              </>}
                  {individual && <>
                <AntTabs
                value={value}
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChange}
              >
                    <AntTab label="Authorized Personnel" {...a11yProps(0)} />
              
                 
                    {(profileDisplay == true || showPanelLicense)  && <AntTab label="Apply Application" {...a11yProps(1)} />}
          
               </AntTabs>
              <TabPanel value={value} index={0}>
                      <CustomerGeneralInfo setShowPanelLicense={setShowPanelLicense} setShowPanelCompany={setShowPanelCompany} setShowMenu={setShowMenu} setRunFirstPanel={setRunFirstPanel} runFirstPanel={runFirstPanel} handleChange={handleChange} setReadableStatus={setReadableStatus} setRestrictedResponse={setRestrictedResponse} setRestrictedStatus={setRestrictedStatus} disableEdit={disableEdit} loading={loading} setLoading={setLoading}/>
            </TabPanel>
                
              {companyDisplay ?

                    <TabPanel value={value} index={1}>


                      <CompanyDetails readableStatus={readableStatus} />

                    </TabPanel> : ""}

                  {(profileDisplay == true || showPanelLicense) ?
                    <TabPanel value={value} index={1}>
                      <ApplicationComponent />
                    </TabPanel> : ""}
                  </>
              }
            </div>
          
        </Grid>
        </Grid>
      
      }
      </>}
    </div>
    </>
  );
}
